import { render, staticRenderFns } from "./tabs-nav-viewport.vue?vue&type=template&id=3c90510e&"
import script from "./tabs-nav-viewport.vue?vue&type=script&lang=js&"
export * from "./tabs-nav-viewport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports